module.exports = __webpack_public_path__ + "media/components/theme/fonts/GTPressuraMono-3127a3ec240e89d5dea08f40f9a59490.woff";